import { render, staticRenderFns } from "./mini-setting.vue?vue&type=template&id=c32401f4&scoped=true&"
import script from "./mini-setting.vue?vue&type=script&lang=ts&"
export * from "./mini-setting.vue?vue&type=script&lang=ts&"
import style0 from "./mini-setting.vue?vue&type=style&index=0&id=c32401f4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c32401f4",
  null
  
)

export default component.exports